import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { WebService } from '../../../services/web/web.service';

@Component({
    selector: 'app-kpi-dashboard',
    templateUrl: './kpi-dashboard.component.html',
    styleUrls: ['./kpi-dashboard.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class KpiDashboardComponent {
    dashboardUrl: SafeResourceUrl | null = null;
    dashboardLoading = true;
    dashboardError = false;

    private readonly dashboardBaseUrl = 'https://datastudio.google.com/embed/reporting/0c94dc2a-aeee-4529-aa91-688cddd1e539/page/p_ny71bbnd8d';

    // Looker Studio no permite compartir un parametro entre fuentes de datos:
    // se envia el mismo valor con un parametro por cada fuente.
    private readonly hashParamNames = ['hash', 'hash2', 'hash3'];

    constructor(private sanitizer: DomSanitizer,
                private webService: WebService) {
    }

    ngOnInit(): void {
        this.loadKpiDashboard();
    }

    loadKpiDashboard(): void {
        this.dashboardLoading = true;
        this.dashboardError = false;

        this.webService.get(`${this.webService.HOST}/api/v1/kpi-dashboard/access`).subscribe({
            next: response => {
                const dashboardAccess = response?.result || response;
                const hash = dashboardAccess?.hash;

                if (!hash) {
                    this.dashboardLoading = false;
                    this.dashboardError = true;
                    return;
                }

                const paramsObject = Object.fromEntries(this.hashParamNames.map(name => [name, hash]));
                const params = encodeURIComponent(JSON.stringify(paramsObject));
                const url = `${this.dashboardBaseUrl}?params=${params}`;
                this.dashboardUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            },
            error: () => {
                this.dashboardLoading = false;
                this.dashboardError = true;
            }
        });
    }

    onDashboardLoad(): void {
        this.dashboardLoading = false;
    }

    onDashboardError(): void {
        this.dashboardLoading = false;
        this.dashboardError = true;
    }
}
